import "ngstorage";

import {WALKTHROUGH_STATES, TRIGGER_NEXT_EVENT_NAME} from "../../variables";

class RequirementsController {
  constructor($localStorage, $rootScope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "requirements";
    this.walkthroughState = WALKTHROUGH_STATES.REQUIREMENTS;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;

    this.ALL_PHYSICAL_REQUIREMENTS = [];
    this.PHYSICAL_REQUIREMENTS = [];

    this.requirements_filter = "";
  }

  $onInit() {
    this.requirements_filter = "";

    this.$events.getAllShiftRequirements().then((s) => {
      this.ALL_PHYSICAL_REQUIREMENTS = s.data;
      this.PHYSICAL_REQUIREMENTS = s.data;
      this.filterRequirements();
    });

    this.$events.getShiftRequirements(this.event.id).then((s) => {
      this.event.requirements = s.data;
      this.filterRequirements();
    });
  }

  filterRequirements() {
    if (!this.ALL_PHYSICAL_REQUIREMENTS || !this.ALL_PHYSICAL_REQUIREMENTS.length || !this.event.requirements) return;

    this.PHYSICAL_REQUIREMENTS = _.differenceBy(this.ALL_PHYSICAL_REQUIREMENTS, this.event.requirements, "id");
    this.PHYSICAL_REQUIREMENTS = _.filter(this.PHYSICAL_REQUIREMENTS, (r) => {
      if (!r || !r.name) return false;
      return (r.name || "").toLowerCase().indexOf((this.requirements_filter || "").toLowerCase()) !== -1;
    });
  }

  goNext() {
    this.$rootScope.$emit(TRIGGER_NEXT_EVENT_NAME, {
      walkthroughState: this.walkthroughState,
    });
  }

  addRequirement(q) {
    console.log(q);
    if (!q) return;

    if (this.event.requirements.length >= 5) {
      this.newRequirement = null;
      this.$tracking.reportPostAJobSubmitStep("more than 5 requirements");
      return alert("You can only have a maximum of 5 requirements.");
    }

    try {
      if (typeof q !== "object") q = JSON.parse(q);
    } catch (e) {
      return console.error(e);
    }

    this.event.requirements.push(q);
    this.newRequirement = null;
    this.requirements_filter = "";

    this.filterRequirements();

    this.$events.addShiftRequirement(this.event.id, q.id, this.event.requirements.length).then((e) => {
      this.$tracking.reportPostAJobSubmitStep("requirements");
      console.log("Added shift requirement:", e);
    });
  }

  removeRequirement(index, requirement) {
    this.event.requirements.splice(index, 1);

    this.filterRequirements();

    this.$events.removeShiftRequirement(this.event.id, requirement.id).then((e) => {
      console.log("Removed shift requirement:", e);
    });
  }
}

RequirementsController.$inject = [
  "$localStorage",
  "$rootScope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
];

export default RequirementsController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/scenes/requirements/requirements.controller.js